export default __webpack_public_path__ + "static/media/list-icon.14c3458c.svg";